import { Box, TextField } from "@mui/material";
import SectionCollapsible from "../../common/SectionCollapsible";
import { ReadOnlyCertifications } from "./ReadOnlyCertifications";
import ReadOnlyProjectDescriptionAnchor from "./ReadOnlyProjectDescriptionAnchor";
import { AssetType, CarbonCreditProgramme } from "../types";

export type ProgrammeInfo = {
  carbonCreditProgramme: Array<CarbonCreditProgramme>;
  accountingMethodology: string;
  projectDescriptionDocument: string;
  assetType?: AssetType | null;
};

export function ReadOnlyProgrammeInfoContainer({
  programmeInfo,
}: {
  programmeInfo: ProgrammeInfo;
}) {
  return (
    <Box data-testid="read-only-programme-info-container">
      <SectionCollapsible label="Programme Info">
        <Box
          sx={{
            paddingBottom: 2,
          }}
        >
          <TextField
            value={programmeInfo?.assetType || "-"}
            variant="standard"
            id="solution-asset-type"
            label="Asset Type (Credit Type)"
            size="small"
            fullWidth
            sx={{
              marginBottom: 2,
            }}
            slotProps={{
              htmlInput: {
                readOnly: true,
              },
            }}
          />
        </Box>
        <Box
          sx={{
            paddingBottom: 2,
          }}
        >
          <ReadOnlyCertifications
            title="Carbon Crediting Programme (Standard)"
            certifications={programmeInfo?.carbonCreditProgramme}
          />
        </Box>
        <Box
          sx={{
            paddingBottom: 4,
          }}
        >
          <TextField
            value={programmeInfo?.accountingMethodology || "-"}
            variant="standard"
            id="carbon-accounting-methodology"
            label="Carbon Accounting Methodology"
            size="small"
            fullWidth
            sx={{
              marginBottom: 2,
            }}
            InputProps={{
              readOnly: true,
              disableUnderline: true,
            }}
          />
        </Box>
        <ReadOnlyProjectDescriptionAnchor
          url={programmeInfo?.projectDescriptionDocument}
        />
      </SectionCollapsible>
    </Box>
  );
}

export default ReadOnlyProgrammeInfoContainer;
